import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LANG_TURKISH } from "./constants/language";
import trTranslations from "./locales/tr/translations.json";
import deTranslations from "./locales/de/translations.json";
import enTranslations from "./locales/en/translations.json";

const resources = {
  tr: {
    translation: trTranslations
  },
  de: {
    translation: deTranslations
  },
  en: {
    translation: enTranslations
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: LANG_TURKISH,
    debug: false,
    keySeparator: true // we do not use keys in form messages.welcome
  });

export default i18n;
